import { ele } from "cables-shared-client";
import api from "../api.js";
import web from "../index.js";

export default class PageProjectExport
{
    constructor(targetElement)
    {
        // (targetEl, id)
        this._settings = {
            "id": targetElement.dataset.id,
            "currentTab": "",
        };
        const minifyCheckbox = ele.byId("export_settings_minify");
        const sourcemapsOption = ele.byId("export_option_sourcemaps");
        if (minifyCheckbox && sourcemapsOption)
        {
            minifyCheckbox.addEventListener("change", () =>
            {
                if (minifyCheckbox.checked)
                {
                    ele.show(sourcemapsOption);
                }
                else
                {
                    ele.hide(sourcemapsOption);
                }
            });
        }
        const tabs = ele.byQueryAll("ul.tab-bar li");
        tabs.forEach((targetEl) =>
        {
            targetEl.addEventListener("activated", (which) =>
            {
                const tabName = targetEl.dataset.tabName;
                const tab = ele.byId("export_options_" + tabName);

                this._settings.currentTab = tabName;
                let exportButtonText = "Export ZIP File";
                if (tabName === "netlify") exportButtonText = "Deploy to Netlify";
                if (tabName === "github") exportButtonText = "Deploy to Github";
                if (tabName === "exe") exportButtonText = "Build Executable";
                if (tabName === "patch")
                {
                    exportButtonText = "Export";
                    ele.byId("export_settings_assets").value = "all";
                }
                ele.byQuery("#exportbutton .button").value = exportButtonText;
                ele.byId("deploymentbutton").value = "View Deployment";
                ele.byId("overviewbutton").innerText = "Deployments overview";

                const hideOptions = { "patch": [
                    "export_option_combine",
                    "export_option_flat",
                    "export_option_minify",
                    "export_option_sourcemaps",
                    "export_option_minify_glsl"
                ] };
                const noOptions = ["cmdline", "iframe"];
                const noButton = ["cmdline", "iframe"];
                if (noOptions.includes(tabName))
                {
                    ele.hide(ele.byId("exportoptions"));
                }
                else
                {
                    const optionsEle = ele.byId("exportoptions");
                    const allOptions = optionsEle.querySelectorAll(".export_option");
                    const checkHide = hideOptions.hasOwnProperty(tabName);
                    allOptions.forEach((optionEle) =>
                    {
                        if (checkHide && hideOptions[tabName].includes(optionEle.id))
                        {
                            ele.hide(optionEle);
                        }
                        else
                        {
                            ele.show(optionEle);
                        }
                    });
                    ele.show(optionsEle);
                }

                if (noButton.includes(tabName))
                {
                    ele.hide(ele.byId("exportbutton"));
                }
                else
                {
                    ele.show(ele.byId("exportbutton"));
                }
            });
        });
    }

    export()
    {
        ele.hide(ele.byId("export_dialog"));
        ele.show(ele.byId("export_loading"));
        ele.hide(ele.byId("exportError"));

        let apiUrl = "project/" + this._settings.id + "/export?a=1";

        apiUrl += "&type=" + this._settings.currentTab;
        apiUrl += "&assets=" + ele.byId("export_settings_assets").value;
        if (ele.byId("export_settings_assets").value === "none") apiUrl += "&ignoreAssets=true";
        if (ele.byId("export_settings_combine").value === "single") apiUrl += "&combineJS=true";
        if (ele.byId("export_settings_flat").checked) apiUrl += "&flat=true";
        if (ele.byId("export_settings_minify").checked)
        {
            if (ele.byId("export_settings_sourcemaps").checked) apiUrl += "&sourcemaps=true";
            apiUrl += "&minify=" + true;
        }
        else
        {
            apiUrl += "&minify=" + false;
        }
        if (ele.byId("export_settings_minify_glsl").checked) apiUrl += "&minifyGlsl=true";

        const options = document.querySelectorAll("#export_options_" + this._settings.currentTab + " .exportOption");
        options.forEach((option) =>
        {
            apiUrl += "&" + option.dataset.name + "=" + encodeURIComponent(option.value);
        });

        api.get(
            apiUrl,
            (res) => { this.exportFinished(null, res); },
            (r) => { this.exportFinished(r, r); });
    }

    exportFinished(err, res)
    {
        ele.hide(ele.byId("export_loading"));
        if (err)
        {
            const errorEle = ele.byId("exportError");
            if (errorEle)
            {
                const msg = errorEle.querySelector(".msg");
                if (msg) msg.innerHTML = err.msg || err;
                ele.hide(ele.byId("retrybutton"));
                ele.show(errorEle);
            }
        }
        else
        {
            const logEle = ele.byId("export_log");
            if (res.log && Array.isArray(res.log))
            {
                res.log.forEach((logEntry) =>
                {
                    if (logEntry.text)
                    {
                        if (logEntry.level === "error")
                        {
                            logEle.innerHTML += "<div class=\"highlightBlock " + logEntry.level + "\">" + logEntry.text + "</div><br/>";
                        }
                        else if (logEntry.level === "info")
                        {
                            const entryEle = document.createElement("li");
                            entryEle.innerHTML = logEntry.text;
                            logEle.appendChild(entryEle);
                        }
                    }
                    else
                    {
                        logEle.innerHTML += "<br/>";
                    }
                });
            }
            else
            {
                logEle.innerHTML = res.log || res.message;
            }
        }

        if (res.urls)
        {
            if (res.urls.downloadUrl)
            {
                ele.show(ele.byId("downloadbutton"));
                ele.byId("downloadbutton").setAttribute("href", res.urls.downloadUrl);
                ele.byId("downloadbutton").click();
            }
            else
            {
                ele.hide(ele.byId("downloadbutton"));
            }

            if (res.urls.deploymentUrl)
            {
                ele.show(ele.byId("deploymentbutton"));
                ele.byId("deploymentbutton").setAttribute("href", res.urls.deploymentUrl);
            }
            else
            {
                ele.hide(ele.byId("deploymentbutton"));
            }

            if (res.urls.overviewUrl)
            {
                ele.show(ele.byId("overviewbutton"));
                ele.byId("overviewbutton").setAttribute("href", res.urls.overviewUrl);
            }
            else
            {
                ele.hide(ele.byId("overviewbutton"));
            }
        }

        ele.hide(ele.byId("export_dialog"));
        ele.show(ele.byId("export_result"));
    }
}
